import { Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { resolveTokens } from '@/theme/theme';

interface OpeningPendingNoteProps {
  /** The accounts counted from 0 because their opening is pending (`openingPendingAccountIds`). */
  count: number;
  /** The surface the note sits on, for its label colour. */
  surface?: 'bg' | 'surface';
}

/**
 * The note on a total that counts pending accounts from 0 (TMMAPP-0123 items 16 and 19a):
 * "Doesn't include a starting balance for {n} accounts". Nothing renders when none is pending.
 */
export function OpeningPendingNote({ count, surface = 'surface' }: OpeningPendingNoteProps) {
  const { t } = useTranslation();
  const tokens = resolveTokens(useTheme());
  if (count <= 0) return null;
  return (
    <Typography
      variant="caption"
      component="div"
      data-opening-pending-note=""
      sx={{ color: tokens.textLabel(surface) }}
    >
      {t('accounts.openingPendingNote', { count })}
    </Typography>
  );
}
